import { render, staticRenderFns } from "./route_history.vue?vue&type=template&id=607e9fb8&scoped=true"
import script from "./route_history.vue?vue&type=script&lang=js"
export * from "./route_history.vue?vue&type=script&lang=js"
import style0 from "./route_history.vue?vue&type=style&index=0&id=607e9fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e9fb8",
  null
  
)

export default component.exports